AUI().use("aui-viewport", "aui-base", "liferay-util-window", "aui-io-plugin-deprecated");
AUI().ready("liferay-hudcrumbs", "liferay-navigation-interaction", "liferay-sign-in-modal", "hh-searchbar", "hh-mainnavi", "hh-bildarchiv", "hh-presseartikel", function(a) {
    console && console.log("%cWillkommen bei HAYS!\n%cIhr Personaldienstleister #1", "font-size:1.5em;color:#4558c9;", "color:#d61a7f;font-size:1em;");
    var b = a.one("#navigation");
    b && b.plug(Liferay.NavigationInteraction);
    (b = a.one("li.sign-in a")) && "true" !== b.getData("redirect") && b.plug(Liferay.SignInModal);
    a.Searchbar.init();
    a.Mainnavi.init();
    a.Bildarchiv.init();
    a.Presseartikel.init();
    b = a.one(".select-country");
    null !== b && (b.on("click", function() {
        a.one(".countries") && ("none" === a.one(".countries").getStyle("display") ? a.one(".countries").setStyle("display", "block") : a.one(".countries").setStyle("display", "none"))
    }),
    b.on("clickoutside", function() {
        var c = a.one(".countries");
        c && c.setStyle("display", "none")
    }));
    b = a.one(".select-myHays");
    null !== b && (b.on("click", function() {
        a.one(".my-hays-meta") && ("none" === a.one(".my-hays-meta").getStyle("display") ? a.one(".my-hays-meta").setStyle("display", "block") : a.one(".my-hays-meta").setStyle("display", "none"))
    }),
    b.on("clickoutside", function() {
        var c = a.one(".my-hays-meta");
        c && c.setStyle("display", "none")
    }))
});
$(document).ready(function() {
    document.querySelectorAll('a[href^\x3d"#"]').forEach(function(a) {
        if(!a.href.includes("liferay")){
            a.addEventListener("click", function(b) {
                b.preventDefault();
                document.querySelector(this.getAttribute("href")).scrollIntoView({
                    behavior: "smooth"
                })
            })
        }
    })
});

function getIndexForScroll(val, by) {
    return by * ((val - val % by) / by);
}

function toggleSelectedLayoutStory(layoutStory, toggle) {
    if (layoutStory.length > 0) {
        $.each(layoutStory.split(" "), function(index, value) {
                $("#layout_"+value).parents(".nav-list__third")[toggle]('set-display-flex');
                $("#layout_"+value).parents(".nav-list__second")[toggle]('set-display-flex');
                $("#layout_"+value)[toggle]("selected-nav-item");
                $("#layout_"+value).find("a").first()[toggle]("selected-nav-item__link");
                if ($("#layout_"+value).length > 0) {
                    if ($("#layout_"+value).position().top > 500) {
                        $("#layout_"+value).parent().animate({scrollTop: getIndexForScroll($("#layout_"+value).position().top, 500)}, 10);
                    }
                }
            });
        }
    }
function navigationHistory(layoutStory) {
    $("ul.nav-list").each(function() {
        if ($(this).children("li").length > 9) {
            $(this).addClass("scrollbar-nav-items");
        }
    });
    let index = 0;
    let firstItem = layoutStory.split(" ").reverse()[0];
    $.each(layoutStory.split(" ").reverse(), function(index, value) {
        $("#layout_"+value).parents("li.top-navigation-flyout-link").find("button.static-flyout-link").addClass("is-active");
        // $("#layout_"+value).parents("li.top-navigation-flyout-link").find("i.icon-chevron-down").addClass("color-dark-blue");
        if (index == 1) {
            if ($("#layout_"+firstItem).parent(".nav-list").children("li").length > $("#layout_"+value).parent(".nav-list").children("li").length && $("#layout_"+value).parent(".nav-list").children("li").length) {
                $("#layout_"+value).parents(".nav-list__second").parent().addClass('compare-children-height');
            }
        }
        if (index == 2) {
            $("#layout_"+value).parents(".nav-list__third").parent().addClass('compare-children-height');
        }
        firstItem = value;
        index++;
    });
}

$(document).ready(function() {
    $(document).click(function(e) {
        if ($(e.target).parents("#contact-menu").length == 0 && $(e.target).parents("#contact-us-button-open").length == 0
            && !$(e.target).hasClass("contact-us") && !$(e.target).hasClass("mobile-menu-icon") && $(e.target).parents(".popup_active").length == 0 || $(e.target).hasClass("icon_close_menu")) {
            $("#contact-us-button-open").fadeIn()
            $("#contact-menu").hide()
            $("#contact-us-button-open").show();
            $("html").css("overflow","");
        }
    });


    $("#contact-us-button-open").click(function () {
        $(this).fadeOut();
        $("#contact-menu").show();
        $("#contact-us-button-open").hide();
    });

    $(".mobile-menu-icon").click(function() {
        $(".mobile-menu-wrapper").removeClass("hidden");
        $("body").addClass("hide-scroll");
        $("#contact-us-button-open").addClass("hidden");
        $("html").css("overflow","hidden");
    });

    $(".icon_close_menu").click(function() {
        $(".mobile-menu-wrapper").addClass("hidden");
        $("body").removeClass("hide-scroll");
        $("#contact-us-button-open").removeClass("hidden");
        $("html").css("overflow","");
    });

    $(".mobile-menu-wrapper").click(function(e) {
        var container = $(".popup.popup_active");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".mobile-menu-wrapper").addClass("hidden");
            $("body").removeClass("hide-scroll");
            $("#contact-us-button-open").removeClass("hidden");
        }
    });

    $(".popup__item").click(function() {
        let that = $(this);
        if ($(this).find("span").length > 0) {
            $.each($(this).attr("class").split(" "), function(index, value) {
                if (value.indexOf("collapse_") >= 0) {
                    $(".popup__menu").addClass("hidden");
                    $(".mobile-navitem-title").addClass("hidden");
                    that.parent().nextAll(".popup__menu."+value+":first").removeClass("hidden");
                    that.parent().nextAll(".mobile-navitem-title."+value+":first").removeClass("hidden");
                }
            });
            $(".row.border_bottom_mobile_menu").addClass("hidden");
            $(".row.button_back_to_mobile_menu").removeClass("hidden");

            if (!$(".row.button_back_to_mobile_menu").find(".button_back_to_mobile_level").hasClass("hidden")) {
                $(".row.button_back_to_mobile_menu").find(".button_back_to_mobile_menu").removeClass("hidden");
            } else {
                $(".row.button_back_to_mobile_menu").find(".button_back_to_mobile_menu").addClass("hidden");
            }

            $(".button_back_to_mobile_level").removeClass("hidden");
        }
    });

    $(".select-mobile-myHays").click(function() {
        $(".popup__menu").addClass("hidden");
        $(".button_back_to_mobile_level").removeClass("hidden");
        $(".row.border_bottom_mobile_menu").addClass("hidden");
        $(".mobile-navitem-title").addClass("hidden");
        $(".row.button_back_to_mobile_menu").removeClass("hidden");
        $(".mobile-navitem-title.collapse_my_hays_mobile_menu").removeClass("hidden");
        $(".popup__menu.collapse_my_hays_mobile_menu").removeClass("hidden");
    });

    $(".button_back_to_mobile_level").click(function() {
        $(".popup__menu").addClass("hidden");
        $(".row.mobile-navitem-title").each(function() {
            if ($(this).hasClass("collapse_my_hays_mobile_menu") && !$(this).hasClass("hidden")) {
                $(".popup__menu").addClass("hidden");
                $(".popup__menu").each(function() {
                    if ($(this).hasClass("collapse_")) {
                        $(this).removeClass("hidden");
                    }
                });

                $(".row.button_back_to_mobile_menu").addClass("hidden");
                $(".row.button_back_to_mobile_menu").find("span").addClass("hidden");
                $(".row.border_bottom_mobile_menu").removeClass("hidden");
                $(".row.mobile-navitem-title").addClass("hidden");
            } else if (!$(this).hasClass("hidden")) {
                $(".row.mobile-navitem-title").addClass("hidden");
                var navClass = $(this).attr("class").split(" ")[2];
                $(this).prevAll().each(function() {
                    if ($(this).find("i."+navClass).length > 0) {
                        $(this).removeClass("hidden");
                        if (!$(this).hasClass("collapse_")) {
                            $(this).prev().removeClass("hidden");
                        }
                        return false;
                    }
                });

                if ($("i."+navClass).parent().parent().hasClass("collapse_")) {
                    $(".row.button_back_to_mobile_menu").addClass("hidden");
                    $(".row.button_back_to_mobile_menu").find("span").addClass("hidden");
                    $(".row.border_bottom_mobile_menu").removeClass("hidden");
                    $(".row.mobile-navitem-title").addClass("hidden");
                }
            }
        });
    });

    $("span.button_back_to_mobile_menu").click(function() {
        $(".popup__menu").addClass("hidden");
        $(".popup__menu").each(function() {
            if ($(this).hasClass("collapse_")) {
                $(this).removeClass("hidden");
            }
        });

        $(".row.button_back_to_mobile_menu").addClass("hidden");
        $(".row.button_back_to_mobile_menu").find("span").addClass("hidden");
        $(".row.border_bottom_mobile_menu").removeClass("hidden");
        $(".row.mobile-navitem-title").addClass("hidden");
    });

    $().ScrollToTop();

    $("#contact-us-button-open").click(function () {
        $(this).fadeOut();
        $("#contact-menu").show(1000);
        $("#contact-us-button-open").hide();
        $("html").css("overflow","hidden");
    });

    $("#contact-us-button-close").click(function () {
        $("#contact-us-button-open").fadeIn()
        $("#contact-menu").hide(1000)
        $("#contact-us-button-open").show();
        $("html").css("overflow","");
    });
    $("#nochatxclose").click(function() {
        $("#nochat").hide();
        $("#nochat-closed").show()
    });
    $("#nochat-closed").click(function() {
        $("#nochat-closed").hide();
        $("#nochat").show()
    })
});


//CPM text accordion mobile only
$(document).ready(function(){
    $('#mobile-text-description').on('hide.bs.collapse', function() {
      $('.arrow-up').addClass('hide').removeClass('show');
      $('.arrow-down').addClass('show').removeClass('hide');
      $('.cpm-text-container').addClass('intro-text').addClass('collapse-view');
    });
        $('#mobile-text-description').on('show.bs.collapse', function (){
            $('.arrow-down').addClass('hide').removeClass('show');
            $('.arrow-up').addClass('show').removeClass('hide');
            $('.horizon-spacing').removeClass('text-truncate-container');
            $('.horizon-spacing').removeClass('height-70');
      $('.cpm-text-container').removeClass('intro-text').removeClass('text-truncate-container').removeClass('collapse-view');
    });
    $(window).on('resize',function(){
    if(parseInt($(window).width())<=600){
    $('.cpm-text-container').addClass('collapse collapse-view').attr('aria-expanded',true);
    }
    else{
    $('.cpm-text-container').removeClass('collapse collapse-view').attr('aria-expanded',false).removeAttr('style');
    }
    })
    $('.cpm-checkbox-container .input-checkbox-wrapper').append("<label/>")
    });

//CPM text accordion desktop oa register-form
$(document).ready(function () {
    $('#accordion-text-description').on('hide.bs.collapse', function () {
        $('.arrow-up').addClass('hide').removeClass('show');
        $('.arrow-down').addClass('show').removeClass('hide');
        $('.cpm-text-container').addClass('intro-text').addClass('collapse-view');
    });
    $('#accordion-text-description').on('show.bs.collapse', function () {
        $('.arrow-down').addClass('hide').removeClass('show');
        $('.arrow-up').addClass('show').removeClass('hide');
        $('.horizon-spacing').removeClass('text-truncate-container');
        $('.horizon-spacing').removeClass('height-35');
        $('.cpm-text-container').removeClass('intro-text').removeClass('text-truncate-container').removeClass('collapse-view');
    });
    $(window).on('resize', function () {
        if (parseInt($(window).width()) <= 600) {
            $('.cpm-text-container').addClass('collapse collapse-view').attr('aria-expanded', true);
        }
        else {
            $('.cpm-text-container').removeClass('collapse collapse-view').attr('aria-expanded', false).removeAttr('style');
        }
    })
    $('.cpm-checkbox-container .input-checkbox-wrapper').append("<label/>")
});

$(document).ready(function () {
    $('#collapse-expand-text-description').on('hide.bs.collapse', function () {
        $('.arrow-up').addClass('hide').removeClass('show');
        $('.arrow-down').addClass('show').removeClass('hide');
        $('.cpm-text-container').addClass('intro-text').addClass('collapse-view');
    });
    $('#collapse-expand-text-description').on('show.bs.collapse', function () {
        $('.arrow-down').addClass('hide').removeClass('show');
        $('.arrow-up').addClass('show').removeClass('hide');
        $('.horizon-spacing').removeClass('text-truncate-container');
        $('.horizon-spacing').removeClass('height-35');
        $('.cpm-text-container').removeClass('intro-text').removeClass('text-truncate-container').removeClass('collapse-view');
    });
    $(window).on('resize', function () {
        if (parseInt($(window).width()) <= 600) {
            $('.cpm-text-container').addClass('collapse collapse-view').attr('aria-expanded', true);
        }
        else {
            $('.cpm-text-container').removeClass('collapse collapse-view').attr('aria-expanded', false).removeAttr('style');
        }
    })
    $('.cpm-checkbox-container .input-checkbox-wrapper').append("<label/>")
});
